import { render, staticRenderFns } from "./WasteSettings.vue?vue&type=template&id=19d91c05&"
import script from "./WasteSettings.vue?vue&type=script&lang=js&"
export * from "./WasteSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports